// In phoneValidation.js

export function validatePhoneNumber(phone) {
    // Clean the number of any spaces or special characters, but handle + separately
    const hasPlus = phone.startsWith('+');
    const cleaned = phone.replace(/\D/g, '');
    
    // If number is too short or too long
    if (cleaned.length < 8 || cleaned.length > 12) {
        return false;
    }
    
    // If starts with '+64' or '64'
    if ((hasPlus && cleaned.startsWith('64')) || cleaned.startsWith('64')) {
        const remainingDigits = cleaned.substring(2);
        return remainingDigits.length >= 8 && remainingDigits.length <= 10;
    }
    
    // If starts with '0'
    if (cleaned.startsWith('0')) {
        const remainingDigits = cleaned.substring(1);
        return remainingDigits.length >= 8 && remainingDigits.length <= 11;
    }
    
    // If just digits without prefix
    return cleaned.length >= 8 && cleaned.length <= 10;
}

export function normalizePhoneNumber(phone) {
    // Remove all non-digit characters
    let cleaned = phone.replace(/\D/g, '');
    
    // If already has +64 or 64 prefix, remove it first
    if (cleaned.startsWith('64')) {
        cleaned = cleaned.substring(2);
    }
    if (cleaned.startsWith('0')) {
        cleaned = cleaned.substring(1);
    }
    
    // Add +64 prefix
    return `+64${cleaned}`;
}